import React from "react"; 
import get from "lodash/get";
import * as Yup from "yup";
import { Formik } from "formik";
import api from "@/services/api";
import useAlert from "@/hooks/useAlert";
import { InstallDateCalendar } from "../../../components";
import "./createOrganization.scss";

const initialValues = {
  tariff_price: "",
  organization_name: "",
  installation_date: "",
};

const validationSchema = Yup.object().shape({
  tariff_price: Yup.string().required("Обязательное поле"),
  organization_name: Yup.string().required("Обязательное поле"),
  installation_date: Yup.string().required("Обязательное поле"),
});

function CreateOrganization({ isOpen, onClose, onSuccess, leadId, regionId, districtId }) {
  const { showAlert } = useAlert();

  const extraParams = {};
  if (regionId) extraParams["filter[region_id]"] = regionId;
  if (districtId) extraParams["filter[district_id]"] = districtId;

  if (!isOpen) return null;

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        api
          .request({
            method: "post",
            url: "/employee/leads/create-organization",
            data: { lead_id: leadId, ...values },
          })
          .then(() => {
            resetForm();
            showAlert("Сохранено", { type: "success", delay: 1000 });
            if (onSuccess) onSuccess();
          })
          .catch((err) => {
            const msg = get(err, "response.data.message");
            showAlert(msg || "Xato!", { type: "danger" });
          })
          .finally(() => setSubmitting(false));
      }}
    >
      {({ values, errors, touched, handleChange, setFieldValue, isSubmitting, handleSubmit, resetForm }) => (
        <div className="org-create-inline">
          <div className="flex flex-wrap -mx-2.5">
            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
              <div className="form-field form-field--small">
                <label className="form-field__label">
                  Название организации <span>*</span>
                </label>
                <input
                  className={"form-field__input" + (touched.organization_name && errors.organization_name ? " --error" : "")}
                  name="organization_name"
                  placeholder="Введите название организации"
                  value={values.organization_name}
                  onChange={handleChange}
                />
                {touched.organization_name && errors.organization_name && (
                  <div className="org-create-inline__error">{errors.organization_name}</div>
                )}
              </div>
            </div>

            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
              <div className="form-field form-field--small">
                <label className="form-field__label">
                  Стоимость тарифа <span>*</span>
                </label>
                <input
                  className={"form-field__input" + (touched.tariff_price && errors.tariff_price ? " --error" : "")}
                  name="tariff_price"
                  placeholder="Введите стоимость тарифа"
                  value={values.tariff_price}
                  onChange={handleChange}
                />
                {touched.tariff_price && errors.tariff_price && (
                  <div className="org-create-inline__error">{errors.tariff_price}</div>
                )}
              </div>
            </div>

            <div className="relative w-full min-h-[1px] px-2.5 grow-0 shrink-0 basis-full max-w-full">
              <InstallDateCalendar
                type="field"
                label="Дата установки"
                required
                size="small"
                extraParams={extraParams}
                disabled={!regionId || !districtId}
                onDateSelect={(date) =>
                  setFieldValue("installation_date", date ? date.format("YYYY-MM-DD") : "")
                }
              />
              {touched.installation_date && errors.installation_date && (
                <div className="org-create-inline__error">{errors.installation_date}</div>
              )}
            </div>
          </div>

          <div className="org-create-inline__actions">
            <button
              type="button"
              className="d-btn d-btn-secondary"
              onClick={() => { resetForm(); onClose(); }}
            >
              Отмена
            </button>
            <button
              type="button"
              className={"d-btn d-btn-primary" + (isSubmitting ? " --loading" : "")}
              disabled={isSubmitting}
              onClick={handleSubmit}
            >
              Добавить
            </button>
          </div>
        </div>
      )}
    </Formik>
  );
}

export default CreateOrganization;
